<div class="form-horizontal">
  <accordion>
    <accordion-group heading="Experiment Settings" [isOpen]="true">
      <div class="form-group">
        <label class="control-label col-sm-2">Requester</label>
        <div class="col-sm-10 form-control-static">{{request.requester}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Delegate</label>
        <div class="col-sm-10 form-control-static">{{request.delegate}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Experiment Title</label>
        <div class="col-sm-10 form-control-static">{{request.title}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Experiment Description</label>
        <div class="col-sm-10 form-control-static">{{request.description}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Compliance Status</label>
        <div class="col-sm-3">
          <table class="table table-bordered">
            <tr class="active">
              <th>Regulatory Status</th>
              <th>PPQ Required?</th>
              <th>Phyto Inspection Required?</th>
            </tr>
            <tr>
              <td>{{request.regulatoryStatus }}</td>
              <td>{{request.ppqRequired  | yesNo }}</td>
              <td>{{request.phytoInspectionRequired  | yesNo }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Site</label>
        <div class="col-sm-10 form-control-static">{{request.ceSite}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Crop</label>
        <div class="col-sm-10 form-control-static">{{request.crop}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Purpose</label>
        <div class="col-sm-10 form-control-static">{{request.requestPurpose}}</div>
      </div>
    </accordion-group>

    <accordion-group heading="Project Settings" [isOpen]="true">
      <div class="form-group">
        <label class="control-label col-sm-2">PMO Program</label>
        <div class="col-sm-10 form-control-static">{{request.pmoProgram}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">PMO Project</label>
        <div class="col-sm-10 form-control-static">{{request.pmoProject}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Product Concepts</label>
        <div class="col-sm-10 form-control-static">{{request.productConcepts}}</div>
      </div>
    </accordion-group>

    <accordion-group heading="Milestones" [isOpen]="true">
      <div class="form-group">
        <label class="control-label col-sm-2">Desired Planting Date</label>
        <div class="col-sm-10 form-control-static">{{request.requestedPlantingDate | date: 'MM/dd/yyyy'}}</div>
      </div>
      <div *ngIf="showColdTreatmentInput">
        <div class="form-group">
          <label class="control-label col-sm-2">Requires Cold Treatment</label>
          <div class="col-sm-10 form-control-static">{{request.weeksOfColdTreatment}}</div>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2">Harvested Seed Available in Packet</label>
        <div class="col-sm-10 form-control-static">{{request.requestedSeedPacketDate | date: 'MM/dd/yyyy'}}</div>
      </div>
    </accordion-group>

    <accordion-group heading="Design Attributes" [isOpen]="true">
      <div class="form-group">
        <label class="control-label col-sm-2">Treatments</label>
        <div class="col-sm-10 form-control-static">{{request.numberOfTreatments}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Replicates</label>
        <div class="col-sm-10 form-control-static">{{request.numberOfReps}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Indexing (Grading Type)</label>
        <div class="col-sm-10 form-control-static">{{request.indexing | yesNo }}</div>
      </div>

      <div class="form-group" *ngIf="isWheatRequest">
        <label class="control-label col-sm-2">Seeds Per Cell</label>
        <div class="col-sm-10 form-control-static">{{request.numberOfSeedsPerCell }}</div>
      </div>
    </accordion-group>

    <accordion-group heading="Seed Needs" [isOpen]="true">
      <div class="form-group">
        <div *ngIf="!request.seedNeeds" class="col-md-offset-2 col-md-10">
          Seed Needs have not been uploaded yet
        </div>

        <div *ngIf="request.seedNeeds">
          <div class="col-md-12">
            <table class="table table-bordered table-striped" *ngIf="isTnRequest">
              <tr class="active">
                <th>Entry Number</th>
                <th>SIID</th>
                <th>GE Name</th>
                <th>Number of Seeds/Cells</th>
                <th>Regulatory Status</th>
                <th>Contains Color Marker?</th>
                <th *ngFor="let treatment of request.seedNeeds[0].treatments">
                  Treatment #{{treatment.treatmentNumber}}
                </th>
              </tr>
              <tr *ngFor="let entry of request.seedNeeds">
                <td>{{entry.entryNumber}}</td>
                <td>{{entry.siid}}</td>
                <td>{{entry.geName}}</td>
                <td>{{entry.numberOfSeeds}}</td>
                <td>{{entry.regulatoryStatus}}</td>
                <td>{{entry.containsColorMarker | yesNo}}</td>
                <ng-container *ngFor="let treatment of entry.treatments">
                  <td>{{treatment.seedCount}}</td>
                </ng-container>
              </tr>
            </table>
          </div>

          <div class="col-md-2">
            <table class="table table-bordered table-striped" *ngIf="isT0Request">
              <tr class="active">
                <th>GEID</th>
                <th>Contains Color Marker?</th>
              </tr>
              <tr *ngFor="let entry of request.seedNeeds">
                <td>{{entry.geid}}</td>
                <td>{{entry.containsColorMarker | yesNo}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Seed Request" [isOpen]="true">
      <div class="form-group">
        <label class="col-sm-2 control-label">Create Seed Request?</label>
        <div class="col-sm-10 form-control-static">{{ request.seedRequestDesired | yesNo }}</div>
      </div>

      <div class="form-group">
        <label class="col-sm-2 control-label">
          Existing Seed Requests
        </label>

        <div class="col-sm-10 form-control-static" *ngIf="seedRequests.length === 0">
          None
        </div>

        <div class="col-sm-4" *ngIf="seedRequests.length > 0">
          <table class="table">
            <thead>
              <tr>
                <th>Seed Request Batch ID</th>
                <th>Batch Creation Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let batch of seedRequests">
                <td>{{ batch.batchId }}</td>
                <td>{{ batch.batchCreationDate | date: 'MM/dd/yyyy' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-sm-10 col-md-offset-2">View Seed Request(s) at <a href="{{ seedRequestUrl }}">{{ seedRequestUrl }}</a> (open with Internet Explorer)</div>
      </div>
    </accordion-group>

    <accordion-group heading="Recurrence" [isOpen]="true">
      <div *ngIf="request.recurrencePattern === 1">
        This is not a recurring request
      </div>

      <div *ngIf="request.recurrencePattern === 2">
        <div class="form-group">
          <label class="control-label col-sm-2">Recurrence Pattern</label>
          <div class="col-sm-10 form-control-static">Every {{ request.recurrenceWeekInterval }} week(s) on {{ request.recurrenceDays | recurrenceDayNames }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">End Date</label>
          <div class="col-sm-10 form-control-static">{{ request.recurrenceEndDate  | date: 'MM/dd/yyyy' }}</div>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Planting Instructions" [isOpen]="true">
      <div class="form-group">
        <div *ngIf="!request.treatments" class="col-md-offset-2 col-md-10">
          Treatments have not been entered yet
        </div>

        <div *ngIf="request.treatments" class="col-md-12">
          <table class="table table-bordered table-striped">
            <tr class="active">
              <th>Treatment</th>
              <th>No. of Seeds to Start</th>
              <th>No. of Plants to Pots</th>
              <th>No. of Plants to Harvest</th>
            </tr>
            <tr *ngFor="let treatment of request.treatments">
              <td>{{ treatment.plantingInstructions.treatmentNumber }}</td>
              <td>{{ treatment.plantingInstructions.seedsToStart }}</td>
              <td>{{ treatment.plantingInstructions.plantsToPots }}</td>
              <td>{{ treatment.plantingInstructions.plantsToHarvest }}</td>
            </tr>
            <tfoot>
              <tr class="totals-border">
                <td>Total</td>
                <td>{{ request.totalSeedsToStart }}</td>
                <td>{{ request.totalPlantsToPots }}</td>
                <td>{{ request.totalPlantsToHarvest }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Flat Seeding/Transplanting Instructions" [isOpen]="true">
      <div class="form-group">
        <div *ngIf="!request.treatments" class="col-md-offset-2 col-md-10">
          Treatments have not been entered yet
        </div>

        <div *ngIf="request.treatments" class="col-md-12">
          <table class="table table-bordered table-striped">
            <tr class="active">
              <th>Treatment</th>
              <th>Direct Seed To Pots</th>
              <th>Container Type</th>
              <th>Substrate</th>
              <th>Irrigation</th>
              <th>Fertigation</th>
            </tr>
            <tr *ngFor="let treatment of request.treatments">
              <td>{{treatment.flatInstructions.treatmentNumber}}</td>
              <td>{{treatment.flatInstructions.directSeedToPots | yesNo}}</td>
              <td>{{treatment.flatInstructions.flatType}}</td>
              <td>{{treatment.flatInstructions.substrate}}</td>
              <td>{{treatment.flatInstructions.irrigationMethod}}</td>
              <td>{{treatment.flatInstructions.fertigationMethod}}</td>
            </tr>
          </table>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Pot Seeding/Transplanting Instructions" [isOpen]="true">
      <div class="form-group">
        <div *ngIf="!request.treatments" class="col-md-offset-2 col-md-10">
          Treatments have not been entered yet
        </div>

        <div *ngIf="request.treatments" class="col-md-12">
          <table class="table table-bordered table-striped">
            <tr class="active">
              <th>Treatment</th>
              <th>Container Type</th>
              <th>Substrate</th>
              <th>Irrigation</th>
              <th>Fertigation</th>
            </tr>
            <tr *ngFor="let treatment of request.treatments">
              <td>{{treatment.pottingInstructions.treatmentNumber}}</td>
              <td>{{treatment.pottingInstructions.potType}}</td>
              <td>{{treatment.pottingInstructions.substrate}}</td>
              <td>{{treatment.pottingInstructions.irrigationMethod}}</td>
              <td>{{treatment.pottingInstructions.fertigationMethod}}</td>
            </tr>
          </table>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Pollination Instructions" [isOpen]="true">
      <div class="form-group">
        <label class="control-label col-sm-2">Pollination Category</label>
        <div class="col-sm-10 form-control-static" *ngIf="request.pollinationInstructions">{{ request.pollinationInstructions.pollinationCategory }}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Preferences</label>
        <div class="col-sm-10 form-control-static" *ngIf="request.pollinationInstructions && request.pollinationInstructions.preferences.length > 0">
          <div class="col-sm-5">
            <ng-container *ngFor="let preferenceGroup of request.pollinationInstructions.preferences; let groupIndex = index">
              <table class="table table-bordered table-striped">
                <caption>{{ (groupIndex > 0 && preferenceGroup.conjunction && !shouldHideConjunction(groupIndex) ? preferenceGroup.conjunction + ' ' : '') + (getGroupLabel(groupIndex) || 'Preference #' + preferenceGroup.order) }}</caption>
                <tr class="active">
                  <th>Priority</th>
                  <th></th>
                  <th>Type</th>
                  <th>GE Name</th>
                </tr>
                <tr *ngFor="let item of preferenceGroup.items">
                  <td>{{ item.order }}</td>
                  <td>{{ item.order != 1 ? item.conjunction : "" }}</td>
                  <td>{{ item.pollinationType }}</td>
                  <td>{{ item.geName }}</td>
                </tr>
              </table>
            </ng-container>
          </div>
        </div>
        <div class="col-sm-10 form-control-static" *ngIf="!request.pollinationInstructions || request.pollinationInstructions.preferences.length === 0">
          Not specified
        </div>
        <div class="form-group" *ngIf="request.pollinationInstructions && (request.pollinationInstructions.pollinationCategory || request.pollinationInstructions.preferences.length > 0)">
          <label class="control-label col-sm-2">Stake Label:</label>
          <div class="col-sm-10 form-control-static" style="white-space: pre-line;">{{ request.pollinationInstructions.stakeLabelString }}</div>
        </div>
      </div>

      <div class="form-group" *ngIf="showDonorNeeded">
        <label class="control-label col-sm-2">Donors Needed?</label>
        <div class="col-sm-10 form-control-static" *ngIf="request.pollinationInstructions">{{ request.pollinationInstructions.donorsNeeded | yesNo }}</div>
      </div>
    </accordion-group>

    <accordion-group heading="Plant Handling Instructions" [isOpen]="true">
      <div class="form-group">
        <div *ngIf="!request.treatments" class="col-md-offset-2 col-md-10">
          Treatments have not been entered yet
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Beneficial Insects Allowed</label>
          <div class="col-sm-10 form-control-static">{{ ceLogistics?.insectsAllowed | yesNo }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Pesticides Allowed</label>
          <div class="col-sm-10 form-control-static">{{request.pesticideInstruction}}</div>
        </div>

        <div class="form-group" *ngIf="showPesticidesAllowedAfterDays">
          <label class="control-label col-sm-2">Duration</label>
          <div class="col-sm-10 form-control-static"
               *ngIf="request.pesticideLifeOfPlant || request.pesticidesAllowedAfterDays > 0">
            <ng-container *ngIf="request.pesticideLifeOfPlant === true">
              Life of plant
            </ng-container>
            <ng-container *ngIf="request.pesticideLifeOfPlant === false">
              Resume standard pesticide application
              <strong>{{ request.pesticidesAllowedAfterDays }}</strong>
              days after planting
            </ng-container>
          </div>
        </div>

        <div *ngIf="request.treatments" class="col-md-12">
          <table class="table table-bordered table-striped">
            <tr class="active">
              <th>Treatment</th>
              <th>Lighting</th>
              <th>Temperature</th>
              <th>Humidity</th>
              <th>Imaging Needed?</th>
              <th *ngIf="showChemicalName">Chemical Name</th>
            </tr>
            <tr *ngFor="let treatment of request.treatments">
              <td>{{treatment.plantHandlingInstructions.treatmentNumber}}</td>
              <td>{{treatment.plantHandlingInstructions.lightingInstruction}}</td>
              <td>{{treatment.plantHandlingInstructions.temperatureInstruction}}</td>
              <td>{{treatment.plantHandlingInstructions.humidityInstruction}}</td>
              <td>{{treatment.plantHandlingInstructions.imagingNeeded | yesNo }}</td>
              <td *ngIf="showChemicalName">{{treatment.plantHandlingInstructions.chemicalName}}</td>
            </tr>
          </table>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Spray Booth Study Instructions" [isOpen]="true">
      <div class="form-group">
        <div *ngIf="!request.treatments" class="col-md-offset-2 col-md-10">
          Treatments have not been entered yet
        </div>

        <div *ngIf="request.treatments" class="col-md-12">
          <ng-container *ngIf="hasSprayEvents(); else noSprayEvents">
            <ng-container *ngFor="let treatment of request.treatments">
              <div *ngIf="treatment.sprayBoothStudyInstructions?.length > 0">
                <h5>Treatment {{ treatment.treatmentNumber }}</h5>
                <table class="table table-bordered styled-table">
                  <thead>
                    <tr class="active">
                      <th style="text-align:center">Spray Event</th>
                      <th style="text-align:center">Application Volume</th>
                      <th style="text-align:center">Application Timepoint</th>
                      <th style="text-align:center">Actives</th>
                      <th style="text-align:center">Adjuvants</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sprayEvent of treatment.sprayBoothStudyInstructions">
                      <td>{{sprayEvent.sprayEventNumber}}</td>
                      <td>{{sprayEvent.applicationVolume}}</td>
                      <td>
                        {{sprayEvent.applicationTimepoint}}
                        <div *ngIf="sprayEvent.sprayEventDaysAfterPlanting > 0">{{sprayEvent.sprayEventDaysAfterPlanting + ' ' + 'DAP' }}</div>
                      </td>
                      <td>
                        <table class="table table-bordered table-striped styled-table-innertable">
                          <thead>
                            <tr>
                              <th>Herbicide Trade Name (FACTSID)</th>
                              <th>Active Ingredient</th>
                              <th>Concentration</th>
                              <th>Rate</th>
                              <th>Relative Field Rate</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let active of sprayEvent.actives">
                              <td>{{active.herbicideTradeName + ' (' + active.factsid + ')'}}</td>
                              <td>{{active.activeIngredient}}</td>
                              <td>{{active.concentrationValue + ' ' + active.concentrationUnit}}</td>
                              <td>{{active.rateValue + ' ' + active.rateUnit}}</td>
                              <td>{{active.relativeFieldRate}}x</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table class="table table-bordered table-striped styled-table-innertable">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Rate</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let adjuvant of sprayEvent.adjuvants">
                              <td>{{adjuvant.adjuvantName}}</td>
                              <td>{{adjuvant.adjuvantValue + ' ' + adjuvant.adjuvantUnit}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </ng-container>

          <ng-template #noSprayEvents>
            <div class="col-md-offset-2 col-md-10">
              No spray booth study instructions
            </div>
          </ng-template>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Harvest Instructions" [isOpen]="true">
      <div class="form-group">
        <label class="control-label col-sm-2">Embryo Rescue?</label>
        <div class="col-sm-10 form-control-static">{{request.embryoRescue | yesNo }}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Minimum # of Seeds to Return</label>
        <div class="col-sm-10 form-control-static">{{request.minimumSeedsToReturn}}</div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-2">Advancement Preferences
          <a tooltip="For Pollination & Mature Harvest Requests, if “For Advancement” is set to “No”, seed will be counted and discarded."
            placement="right" container="body">
            <span class="glyphicon glyphicon-info-sign"></span>
          </a>
        </label>
        <div class="col-sm-3">
          <table class="table table-bordered">
            <tr class="active">
              <th>For Advancement?</th>
              <ng-container *ngIf="request.standardHarvest">
                <th>Haploid Induction?</th>
                <th>Many-to-One?</th>
                <th>Unique Pedigree?</th>
              </ng-container>
            </tr>
            <tr>
              <td>{{ request.standardHarvest | yesNo }}</td>
              <ng-container *ngIf="request.standardHarvest">
                <td>{{ request.haploidInduction | yesNo }}</td>
                <td>{{ request.manyToOne | yesNo }}</td>
                <td>{{ request.uniquePedigree | yesNo }}</td>
              </ng-container>
            </tr>
          </table>
        </div>
      </div>
    </accordion-group>

    <accordion-group heading="Sampling Needs" [isOpen]="true">
      <app-sampling-needs-grid [requestedSamplings]="request.requestedSamplings"
                               [includeNotes]="false">
      </app-sampling-needs-grid>
    </accordion-group>

    <accordion-group heading="CE Logistics" [isOpen]="true">
      <span *ngIf="!ceLogistics">Loading CE Logistics...</span>

      <div *ngIf="ceLogistics">
        <div class="form-group">
          <label class="control-label col-sm-2">Tactical Liaison</label>
          <div class="col-sm-10 form-control-static">{{ceLogistics.tacticalLiaison }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Tags Only?</label>
          <div class="col-sm-10 form-control-static">{{ ceLogistics.tagsOnly  | yesNo }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Planned AOI Location</label>
          <div class="col-sm-10 form-control-static" *ngIf="ceLogistics.specificAoiRequired">{{ ceLogistics.plannedAoiLocation }}</div>
          <div class="col-sm-10 form-control-static" *ngIf="!ceLogistics.specificAoiRequired">AOI location not specified</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Notes</label>
          <div class="col-sm-10 form-control-static">{{ceLogistics.notes }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Plant Care Template</label>
          <div class="col-sm-10 form-control-static">{{ceLogistics.plantCareTemplate }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Request Type</label>
          <div class="col-sm-10 form-control-static">{{ ceLogistics.requestType }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Planned Plant Date</label>
          <div class="col-sm-10 form-control-static">{{ ceLogistics.plannedPlantingDate  | date: 'MM/dd/yyyy' }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Facility</label>
          <div class="col-sm-10 form-control-static">{{ceLogistics.facilityType }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">PRISM Experiment Name</label>
          <div class="col-sm-10 form-control-static">{{ceLogistics.prismExperimentName }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">AOI</label>
          <div class="col-sm-10 form-control-static">{{ceLogistics.aoi }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Actual Plant Date</label>
          <div class="col-sm-10 form-control-static">{{ ceLogistics.actualPlantDate  | date: 'MM/dd/yyyy' }}</div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2">Treatment Details</label>
          <div class="col-sm-10 form-control-static">
            <accordion>
              <accordion-group [isOpen]="true" *ngFor="let treatmentDetail of ceLogistics.treatmentDetails">
                <div accordion-heading>Treatment {{treatmentDetail.treatmentNumber}}</div>
                <app-planning-treatment-detail [treatmentDetail]="treatmentDetail"></app-planning-treatment-detail>
              </accordion-group>
            </accordion>
          </div>
        </div>

        <app-sampling-needs-grid *ngIf="ceLogistics.requestedSamplings"
                                 [requestedSamplings]="ceLogistics.requestedSamplings"
                                 [includeNotes]="true">
        </app-sampling-needs-grid>
      </div>
    </accordion-group>

    <accordion-group heading="Comments" [isOpen]="true">
      <div class="row col-md-12" *ngFor="let comment of requestComments">
        <hr>
        <div class="col-sm-2">
          <p>{{comment.createdBy}}</p>
          <p>{{comment.createdOn | date:'short'}}</p>
          <p>{{comment.source}}</p>
        </div>
        <div class="col-sm-10">{{comment.comment}}</div>
      </div>
    </accordion-group>

  </accordion>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/review-request/review-request.component.html